import { Link } from "react-router-dom";

const SHORTCUTS = [
  {
    to: "/category/movie",
    icon: "ri-film-line",
    title: "电影",
    desc: "院线新片、经典片单与类型片推荐",
    tone: "bg-primary-100 text-primary-700",
  },
  {
    to: "/category/tv",
    icon: "ri-tv-2-line",
    title: "电视剧",
    desc: "热播剧集、分集目录与追剧指南",
    tone: "bg-accent-100 text-accent-700",
  },
  {
    to: "/category/news",
    icon: "ri-newspaper-line",
    title: "影视资讯",
    desc: "上映预告、行业动态与幕后报道",
    tone: "bg-secondary-100 text-secondary-800",
  },
];

export default function CategoryShortcuts() {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mt-4">
      {SHORTCUTS.map((item) => (
        <Link
          key={item.to}
          to={item.to}
          className="group flex items-start gap-3 p-3.5 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
        >
          <span className={`w-10 h-10 rounded-md flex items-center justify-center shrink-0 ${item.tone}`}>
            <i className={`${item.icon} text-lg w-5 h-5 flex items-center justify-center`} />
          </span>
          <span className="min-w-0">
            <span className="flex items-center gap-1 text-sm font-semibold text-foreground-950 group-hover:text-accent-700 transition-colors">
              {item.title}
              <i className="ri-arrow-right-up-line text-xs text-foreground-400 w-3.5 h-3.5 flex items-center justify-center" />
            </span>
            <span className="block text-xs text-foreground-500 mt-0.5 leading-relaxed">{item.desc}</span>
          </span>
        </Link>
      ))}
    </div>
  );
}